import React, { useState } from "react";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import ViewModule from "@mui/icons-material/ViewModule";

// core components
import OthelloBotonera from '../../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, TipoOthelloFieldGrid, Roles, PopUpResult, OpcionVisibilidad, OrdenacionCategoria, OpcionSiNo } from "../../othelloConstantes.jsx";
import OthelloGrid from '../../componentsothello/OthelloGrid.jsx';
import OthelloEdit from '../../componentsothello/OthelloEdit.jsx';
import ImageUpload from "../../components/ImageUpload.jsx";
import OthelloPopUpResult from "../../componentsothello/OthelloPopUpResult.jsx";
import OthelloComboBox from '../../componentsothello/OthelloComboBox.jsx';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import OthelloTituloPanelData from "../../componentsothello/OthelloTituloPanelData.jsx";


export default function Categorias({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [datacategorias, setdatacategorias] = React.useState(null);
    const [nombretienda, setnombretienda] = React.useState("");

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    React.useEffect(() => {

        setLoading(false);
        getDataNombreTienda();
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataNombreTienda = () => {
        fetch('api/Data/GetNombreTiendaSelected')
            .then(response => response.json())
            .then(data => {
                setnombretienda(data.nombre);
            });
    }

    const getDataPage = () => {

        fetch('api/Data/GetCategorias')
            .then(response => response.json())
            .then(data => {
                setdatacategorias(data);
            });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetCategoriaVacia')
            .then(response => response.json())
            .then(data => {
                setdataeditando(data);
                setstatePage(DataStatePage.dsInsert);

            }).catch(error => {
                setdataeditando(null);
            });;
    }

    const grabarDataPage = (event) => {
        //Obtengo los datos
        let formulario = document.getElementById('formcategoria');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarCategoria', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            if (indexeditando == -1) {

                var array = [...datacategorias];
                array.push(res);
                setdatacategorias(array);
            }
            else {
                var array = [...datacategorias];
                array[indexeditando] = res;
                setdatacategorias(array);
            }

            setdataeditando(null);
            setindexeditando(null);
            setstatePage(DataStatePage.dsSearch);

            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => {

        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVacia();
        setindexeditando(-1);
    }

    const buscarDataPage = () => {
        setdataeditando(null);
        setindexeditando(null);
        setstatePage(DataStatePage.dsSearch);
    }

    const cancelarDataPage = () => {
        setdataeditando(null);
        setindexeditando(null);
        setstatePage(DataStatePage.dsSearch);
    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1)
            setstatePage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
        //  this.forceUpdate()
    }

    //METODO SOBRE EL GRID    
    const editGridDataPage = (valor, index) => {
        setdataeditando(valor);
        setindexeditando(index);
        setstatePage(DataStatePage.dsEdit);
    }

    const deleteGridDataPage = (valor, index) => {


        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Categoria);

            fetch('api/Data/EliminarCategoria', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);

                    if (datacategorias != null) {
                        var array = [...datacategorias]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);
                        setdatacategorias(array);

                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearch(categoriaes) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = props.idRol == Roles.SuperUsuario ? ["Categoria", "Codigo", "Ordenado", "Orden Visual", "Visible", "Icono", "Imagen"] : ["Codigo", "Ordenado", "Orden Visual", "Visible", "Icono", "Imagen"];
        let valoreshow = props.idRol == Roles.SuperUsuario ? ["id_Categoria", "codigo", "ordenadoPor", "ordenVisual", "visible", "icono", "image"] : ["codigo", "ordenadoPor", "ordenVisual", "visible", "icono", "image"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "ordenadoPor", items: OrdenacionCategoria });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "icono", items: [] });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "image", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={categoriaes} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={deleteGridDataPage} />);
    }

    function renderInsertEdit(categoria) {

        if (categoria != null) {
            let name = "Nueva Categoria";
            let Nombre = categoria != null && categoria.id_Categoria > 0 ? "Editar " + categoria.codigo : name;

            return (<OthelloTituloPanelData icon="view_module" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                        </Grid>
                    </Grid>
                    <form id="formcategoria" >
                        <Grid container>
                            <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={categoria.id_Oficina} />
                            <input id="Id_Categoria" name="Id_Categoria" type="hidden" value={categoria.id_Categoria} />
                            <input id="Id_Poi" name="Id_Poi" type="hidden" value={categoria.id_Poi} />
                            <Grid item xs={6} sm={2} lg={1}>
                                <OthelloEdit label="Codigo" fieldname="codigo" currentvalue={categoria.codigo} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={3}>
                                <OthelloEdit label="Descripcion" fieldname="descripcion" currentvalue={categoria.descripcion} />
                            </Grid>
                            <Grid item xs={6} sm={2} lg={1}>
                                <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} currentvalue={categoria.visible} />
                            </Grid>
                            <Grid item xs={6} sm={2} lg={1}>
                                <OthelloComboBox label='Ordenado' fieldname="ordenadoPor" items={OrdenacionCategoria} currentvalue={categoria.ordenadoPor} />
                            </Grid>
                            <Grid item xs={6} sm={3} lg={2}>
                                <OthelloEdit label="Orden Visual" fieldname="ordenVisual" currentvalue={categoria.ordenVisual} />
                            </Grid>
                            <Grid item xs={6} sm={2} lg={1}>
                                <OthelloComboBox label='Destacada' fieldname="destacada" items={OpcionSiNo} currentvalue={categoria.destacada} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6} sm={2}>
                                <br />
                                <legend>Icono (48x48px)</legend>
                                <ImageUpload
                                    id="Icono" name="Icono"
                                    imageUrl={categoria.icono}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <br />
                                <legend>Imagen</legend>
                                <ImageUpload
                                    id="Image" name="Image"
                                    imageUrl={categoria.image}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearch(datacategorias)

    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEdit(dataeditando) : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let tiendaname = nombretienda != "" ? nombretienda : "";

    let titulo = "Categorias " + tiendaname;

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData titulo={titulo} margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>
    );
}

